import {template as tpl, viewModel as SearchBasic} from "../../../../object/search.basic";
import {IObjectData, IRouteDefinitionParams, ITableColumn} from "../../../../../index";
import {ObjectTypeId} from "../../../../../constants";
import {storeObservable} from "../../../../../util/sessionstore";
import pick_objectHtml from './pick-object.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', pick_objectHtml);

interface IParams {
    objectData: KnockoutObservable<IObjectData>
    objectTypeId: ObjectTypeId
}

export class viewModel extends SearchBasic {
    private objectData: KnockoutObservable<IObjectData>;
    private templateRow = 'tpl__pickUser';
    readonly table: ITableColumn[];

    constructor(params: IParams & IRouteDefinitionParams) {
        super(params);
        this.objectData = params.objectData;
        this.objecttypeid = params.objectTypeId;
        const columns = storeObservable(`search.object.syncfields${this.objecttypeid}`)();
        this.table = columns.map((key: string) => ({
            key: key,
            label: key,
            sort: true,
        }));
        this.searchcolumn(columns[0]);
    }

    onRowClick(data: IObjectData) {
        this.objectData(data);
    }
}
